import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'app-accordion-header-empty',
    templateUrl: './accordion-header-empty.component.html',
    styleUrls: ['./accordion-header-empty.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AccordionHeaderEmptyComponent implements OnInit {
    @Input() actionIcon = 'fa-arrow-right';
    @Input() icon = 'fa-cube';
    @Input() title: string;
    @Output() click = new EventEmitter();

    ngOnInit() {
    }

    onClick(event) {
        this.click.emit(event);
        event.preventDefault();
    }
}
